import "./App.css";
import Dictionary from "./Dictionary";

export default function App() {
return (
<div className="App">
<div className="container">
<header className="App-header">
  <h1 className="app-title">WordWave 🌊</h1>
</header>
<main>
<Dictionary />
</main>
</div>
</div>
);
}